class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      // document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
      this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // const applyfilter = this.querySelector('.apply-filter');
    // if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));    
    const filterbtn = this.querySelector('.filter-button');
    const filterclose = this.querySelector('.filter-close');
    const sortbtn = this.querySelector('.sort-button');
    const showbtn = this.querySelector('.show-button');
    
    function productcarousel(){
      var productslider=[];
      document.querySelectorAll('.facet-list-wrap').forEach(function(Element,index){
        let productid = Element.dataset.id;
        let swiperObject = {
          slidesPerView: "auto",
          mousewheel: {
            releaseOnEdges: true,
          },
          navigation: {
            nextEl: Element.querySelector('.swiper-button-next'),
            prevEl: Element.querySelector('.swiper-button-prev'),
          },
        };
        productslider[productid]=new Swiper(Element,swiperObject);
      });
    }
    productcarousel();
        
    if(filterbtn) filterbtn.addEventListener('click',function(e){
      productcarousel();
      document.querySelector('body').classList.toggle('open-filter');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search');
      filterprice();
    });
    if(filterclose) filterclose.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
    if (showbtn) showbtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
    if(sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
    });
    if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(typeof initProductGridSliders == 'function'){
        initProductGridSliders();
      }
    });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderActiveFilter(html);
    if(typeof quickAddButton == 'function'){
      quickAddButton();
    }
    if(typeof initProductGridSliders == 'function'){
      initProductGridSliders();
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
    // console.log('count',count);
    // document.querySelector('.coll-main-count').textContent = count;
    document.querySelector('.filter-total-count').textContent = '('+count+')';

    attachClickEvent();
    autoClickMoreLink();
    if(typeof initProductGridSliders == 'function'){
      initProductGridSliders();
    }
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('.filter-index');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  onSubmitHandler(event) {    
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
        // Check if the availability parameter already exists
    if (!formData.has('filter.v.availability')) {
      formData.append('filter.v.availability', '1');
    }
    if (!formData.has('filter.v.m.custom.available')) {
      formData.append('filter.v.m.custom.available', '1');
    }
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);    
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function filterprice() {
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var priceLeft = document.querySelector(".amount-wrap > .amount-left");
  var priceRight = document.querySelector(".amount-wrap > .amount-right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var min = parseInt(inputLeft.min);
    var max = parseInt(inputLeft.max);
    inputLeft.value = Math.min(parseInt(inputLeft.value), parseInt(inputRight.value) - 1);
    var percent = ((inputLeft.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    priceLeft.style.left = 'calc('+percent+'% - '+ (document.querySelector(".amount-wrap > .amount-left").offsetWidth/2) +'px)';
    amountLeft.innerHTML = inputLeft.value;
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var min = parseInt(inputRight.min);
    var max = parseInt(inputRight.max);
    inputRight.value = Math.max(parseInt(inputRight.value), parseInt(inputLeft.value) + 1);
    var percent = ((inputRight.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    priceRight.style.right = 'calc('+(100 - percent)+'% - '+ (document.querySelector(".amount-wrap > .amount-right").offsetWidth/2) +'px)';
    amountRight.innerHTML = inputRight.value;
    range.style.right = (100 - percent) + "%";
    inputRight.style.zIndex = 3;
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}
if(document.querySelector('.range-wrap')){
  filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()



// infinitescroll

var pInfScrLoading = false;
var pInfScrDelay = 250;
var pInfScrExecuting = false; // Add a flag to indicate if the function is executing

function pInfScrExecute() {
  if (pInfScrExecuting) return; // Prevent multiple executions
  pInfScrExecuting = true; // Set the flag to true

  var pInfScrNode = document.querySelectorAll('.load-more').item(document.querySelectorAll('.load-more').length - 1);
  var pInfScrURL = document.querySelectorAll('.load-more a').item(document.querySelectorAll('.load-more a').length - 1).getAttribute("href");

  // Check if the URL is the same as the current page URL
  if (pInfScrURL === window.location.href) {
    pInfScrExecuting = false; // Reset the flag
    return;
  }

  if (pInfScrNode && pInfScrNode.style.display !== 'none') {
    fetch(pInfScrURL, {
      method: 'GET'
    })
    .then(response => response.text())
    .then(data => {
      pInfScrLoading = true;
      var cloneNode = pInfScrNode.cloneNode(true);
      cloneNode.innerHTML = '';
      cloneNode.insertAdjacentHTML('beforeend', '<img src="https://cdn.shopify.com/s/files/1/0641/4857/0345/files/ajax-loader.gif?v=1730124869" />');
      pInfScrNode.insertAdjacentElement('afterend', cloneNode);
      pInfScrNode.style.display = 'none';
      // console.log('pInfScrNode display none:', pInfScrNode);
      // remove loading feedback
      cloneNode.remove();
      pInfScrNode.remove();

      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = data;
      var newGridHtml = tempDiv.querySelector("#product-grid").innerHTML;
      // Deduplicate: only append product-items we don't already have (fixes double append when Ajaxinate + observer both run)
      var existingIds = new Set(
        Array.from(document.querySelectorAll('#product-grid .product-item[data-product-id]'))
          .map(function (el) { return el.getAttribute('data-product-id'); })
          .filter(Boolean)
      );
      var parseDiv = document.createElement('div');
      parseDiv.innerHTML = newGridHtml;
      parseDiv.querySelectorAll('.product-item[data-product-id]').forEach(function (item) {
        if (existingIds.has(item.getAttribute('data-product-id'))) item.remove();
      });
      var filteredData = parseDiv.innerHTML;
      if (filteredData.trim()) {
        document.querySelector("#product-grid").insertAdjacentHTML('beforeend', filteredData);
      }
      removeDuplicateProductItems();

      pInfScrLoading = false;
      attachClickEvent();
      scheduleAutoClickMoreLinkRetry(); // Re-attach observer; retry if DOM not ready yet (slow networks/devices)
      pInfScrExecuting = false; // Reset the flag after execution
      if(typeof initProductGridSliders == 'function'){
        initProductGridSliders();
      }
      if(typeof gridcarousel == 'function'){
        gridcarousel();
      }
    })
    .catch(() => {
      pInfScrExecuting = false; // Reset the flag in case of an error
    });
  } else {
    pInfScrExecuting = false; // Reset the flag if conditions are not met
  }
}

/**
 * Remove duplicate .product-item elements in #product-grid by data-product-id (keeps first of each).
 * Prevents duplicate products when both Ajaxinate and custom load-more run.
 */
function removeDuplicateProductItems() {
  var grid = document.querySelector('#product-grid');
  if (!grid) return;
  var seen = new Set();
  grid.querySelectorAll('.product-item[data-product-id]').forEach(function (item) {
    var id = item.getAttribute('data-product-id');
    if (id && seen.has(id)) item.remove();
    else if (id) seen.add(id);
  });
}

function attachClickEvent() {
  document.querySelectorAll('.load-more a').forEach(anchor => {
    anchor.addEventListener('click', function(event) {
      event.preventDefault();
      pInfScrExecute();
      event.stopPropagation();
      return false;
    });
  });

  // Save scroll position and loaded products before navigating to the product page
  document.querySelectorAll('#product-grid a').forEach(anchor => {
    anchor.addEventListener('click', function() {
      sessionStorage.setItem('scrollPosition', window.scrollY);
      saveLoadedProducts();
    });
  });
}

// Save the HTML content of the loaded products
function saveLoadedProducts() {
  var loadedProducts = document.querySelector("#product-grid").innerHTML;
  sessionStorage.setItem('loadedProducts', loadedProducts);
  var scrollPosition = window.scrollY;
  sessionStorage.setItem('scrollPosition', scrollPosition);
  sessionStorage.setItem('collectionURL', window.location.href);
}

// Restore scroll position and loaded products when the page is loaded
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/collections')) {
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    var loadedProducts = sessionStorage.getItem('loadedProducts');
    var collectionURL = sessionStorage.getItem('collectionURL');
    if (loadedProducts && collectionURL === window.location.href) {
      document.querySelector("#product-grid").innerHTML = loadedProducts;
      removeDuplicateProductItems();
      sessionStorage.removeItem('loadedProducts');
      if(typeof initProductGridSliders == 'function'){
        initProductGridSliders();
      }
    }
    if (scrollPosition && collectionURL === window.location.href) {
      window.scrollTo(0, scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
    attachClickEvent();
  }
});

// Save state when clicking on a product link
document.addEventListener('click', function(event) {
  if (event.target.closest('.snippet-product-grid a')) {
    saveLoadedProducts();
  }
});

// Save scroll position before the user leaves the page
window.addEventListener('beforeunload', function() {
  sessionStorage.setItem('scrollPosition', window.scrollY);
});


// Clear sessionStorage when navigating to a new collection
document.querySelectorAll('.snippet-collection-navigation .dp-container a').forEach(anchor => {
  anchor.addEventListener('click', function() {
    sessionStorage.clear();
  });
});

// Restore scroll position when the page is shown (including back navigation)
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    if (scrollPosition) {
      window.scrollTo(0, scrollPosition);
      sessionStorage.removeItem('scrollPosition');
    }
  }
});

var autoClickMoreLinkRetryTimeouts = [];

/**
 * Attach IntersectionObserver to #load-more a so scrolling triggers load more.
 * Returns true if a link was found and observer attached (or already attached), false if no link in DOM.
 * Avoids double-observing the same link via data-load-more-observed.
 */
function autoClickMoreLink() {
  var moreLink = document.querySelector('#load-more a');
  if (!moreLink) return false;
  if (moreLink.getAttribute('data-load-more-observed') === 'true') return true;

  moreLink.setAttribute('data-load-more-observed', 'true');

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        moreLink.click();
        observer.unobserve(moreLink);
        setTimeout(function() { scheduleAutoClickMoreLinkRetry(); }, 1000);
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  });

  observer.observe(moreLink);
  return true;
}

/**
 * Retry schedule (ms) for slow DOM updates / slow networks / busy main thread.
 * Covers from fast (0) up to ~12s so slow devices and 3G get the observer.
 */
var AUTO_CLICK_MORE_LINK_DELAYS = [0, 200, 500, 1000, 2000, 4000];
var AUTO_CLICK_MORE_LINK_MAX_INDEX = 5;

function scheduleAutoClickMoreLinkRetry() {
  if (!window.location.pathname.includes('/collections')) return;
  clearAutoClickMoreLinkRetries();
  var index = 0;

  function tryAttach() {
    if (autoClickMoreLink()) {
      clearAutoClickMoreLinkRetries();
      return;
    }
    index += 1;
    if (index <= AUTO_CLICK_MORE_LINK_MAX_INDEX) {
      var delay = AUTO_CLICK_MORE_LINK_DELAYS[index];
      var tid = setTimeout(tryAttach, delay);
      autoClickMoreLinkRetryTimeouts.push(tid);
    }
  }

  tryAttach();
}

function clearAutoClickMoreLinkRetries() {
  autoClickMoreLinkRetryTimeouts.forEach(function(id) { clearTimeout(id); });
  autoClickMoreLinkRetryTimeouts = [];
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/collections')) removeDuplicateProductItems();
  scheduleAutoClickMoreLinkRetry();
});

window.removeDuplicateProductItems = removeDuplicateProductItems;